
import {apiSlice} from './apiSlice';

export interface AttendanceRequest {
    projectId: string;
    siteCode: string;
    deviceId: string;
}

export interface SignOutEmployeeRequest {
    siteCode: string;
    deviceId: string;
}

const ATTENDANCE_URL = '/api/attendance';

export const attendanceApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        signInEmployeeRequest: builder.mutation<any, AttendanceRequest>({
            query: (body: any) => ({
                url: `${ATTENDANCE_URL}/sign-in`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ["AttendanceEvents", "EmployeeWorkSessions", "CurrentSession"],
        }),

        signOutEmployeeRequest: builder.mutation<any, SignOutEmployeeRequest>({
            query: (body: any) => ({
                url: `${ATTENDANCE_URL}/sign-out`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ["AttendanceEvents", "EmployeeWorkSessions", "CurrentSession"],
        }),

        fetchAllUserHours: builder.query({
            query: ({userId, projectId}) => ({
                url: `${ATTENDANCE_URL}/employee/${userId}/${projectId}`,
                method: 'GET',
            }),
            providesTags: ["AttendanceEvents", "EmployeeWorkSessions"],
        }),

        listProjectHoursPerWeek: builder.query({
            query: (projectId: string) => ({
                url: `${ATTENDANCE_URL}/project/${projectId}`,
                method: 'GET',
            }),
            providesTags: ["AttendanceEvents", "EmployeeWorkSessions"],
        }),

        createEmployeeHours: builder.mutation({
          query:({userId, projectId, signInTime, signOutTime} :{
              userId: string,
              projectId: string,
              signInTime: string,
              signOutTime: string
          }) => ({
              url: `${ATTENDANCE_URL}/createHours/${userId}`,
              method: 'POST',
              body: {
                  projectId,
                  signInTime,
                  signOutTime,
              }
          }),
            invalidatesTags: ["AttendanceEvents", "EmployeeWorkSessions"],
        }),

        updateEmployeeHoursWorked: builder.mutation({
            query: ({userId, projectId, userName, signInTime, signOutTime, sessionId}: {
                userId: string,
                sessionId: any,
                projectId: string,
                userName: string,
                signInTime: any,
                signOutTime: any,
            }) => ({
                url:`${ATTENDANCE_URL}/update/hours/${sessionId}`,
                method:'PUT',
                body: {
                    userName,
                    signInTime,
                    signOutTime,
                    userId,
                    projectId
                }
            }),
            invalidatesTags: ["AttendanceEvents", "EmployeeWorkSessions"]
        }),

        deleteEmployeeHours: builder.mutation({
            query: (sessionId: string) => ({
                url: `${ATTENDANCE_URL}/hours/${sessionId}`,
                method: 'DELETE',
            })
        }),

        attendanceSearchAllUsers: builder.mutation({
            query:({userId, sessionId, messageContent, role}: {
                userId: string,
                sessionId: string,
                messageContent: string,
                role: string
            }) => ({
                url:`${ATTENDANCE_URL}/hoursSearch/${userId}`,
                method:'POST',
                body: {
                    sessionId,
                    messageContent,
                    role
                }
            }),
            invalidatesTags: ["AttendanceEvents", "EmployeeWorkSessions"]
        }),

        askAttendanceQuestion: builder.mutation({
            query:({userId, sessionId, messageContent, role}:{
                userId:string,
                sessionId: string,
                messageContent:string,
                role: "User"}) => ({
                url: `${ATTENDANCE_URL}/semanticSearch/${userId}`,
                method: 'POST',
                body: {
                    sessionId,
                    messageContent,
                    role
                }
            }),
            invalidatesTags: ["AttendanceEvents", "EmployeeWorkSessions"]
        }),

        getCurrentWorkSession: builder.query({
            query: (userId: string) => ({
                url: `${ATTENDANCE_URL}/current/${userId}`,
                method: 'GET',
            }),
            providesTags: ["CurrentSession"],
        }),

    })
})

export const {
    useSignInEmployeeRequestMutation,
    useSignOutEmployeeRequestMutation,
    useGetCurrentWorkSessionQuery,
    useFetchAllUserHoursQuery,
    useAttendanceSearchAllUsersMutation,
    useUpdateEmployeeHoursWorkedMutation,
    useListProjectHoursPerWeekQuery,
    useCreateEmployeeHoursMutation,
    useDeleteEmployeeHoursMutation,
   // useAskAttendanceQuestionMutation,
} = attendanceApiSlice;